import * as React from 'react'
import Container from '../../components/Messenger/Container'
import styled from 'styled-components'
import CollectionItem from '../../components/Messenger/Help/CollectionItem'
import { useTranslation } from 'react-i18next'
import { ArticleCollection, Locale } from '../../../types'
import { HelpCenterController } from '../../controllers'
import PageLoader from '../../../help_center/components/Loader/PageLoader'
import MobilityHelper from '../../../helpers/MobilityHelper'
import { useSelector } from 'react-redux'
import { AppState } from '../../store'
import FadeInContainer from '../../components/Messenger/Animation/FadeInContainer'
import ScrollToTopOnMount from '../../effects/ScrollToTopOnMount'

const Title = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-weight: 600;
  line-height: 24px;
  color: rgb(26, 26, 26);
  font-size: 16px;
`

const Collections = styled.div`
  display: flex;
  flex-direction: column;
`

interface IState {
  articleCollections: ArticleCollection[]
  didInitialLoad: boolean
}

const HelpOverview = () => {
  const { t } = useTranslation()
  const { locale } = useSelector((state: AppState) => state.application)
  const [state, setState] = React.useState<IState>({
    articleCollections: [],
    didInitialLoad: false
  })

  const { articleCollections, didInitialLoad } = state

  const fetchCollections = async () => {
    try {
      const { article_collections } = await HelpCenterController.getOverview()

      setState({
        didInitialLoad: true,
        articleCollections: article_collections
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  React.useEffect(() => {
    fetchCollections().catch(console.error)
  }, [])

  if (!didInitialLoad) {
    return <PageLoader />
  }

  const localeArticleCollectionsCount = articleCollections.filter(collection => Boolean(MobilityHelper.getTranslation(locale, collection.translations, 'title'))).length

  return (
    <FadeInContainer>
      <ScrollToTopOnMount />
      <Container>
        <Title>{t('HelpOverview::{{count}} collections', { count: localeArticleCollectionsCount })}</Title>

        {localeArticleCollectionsCount > 0 && <Collections>
          {articleCollections.map((articleCollection) => {
            if (articleCollection.articles_count === 0) return null

            return (
              <CollectionItem
                key={articleCollection.id}
                collection={articleCollection}
              />
            )
          })}
        </Collections>}
      </Container>
    </FadeInContainer>
  )
}

export default HelpOverview